/** Button and input classes from DESIGN §9 "Buttons and inputs". */
const BTN_BASE =
  'inline-flex items-center justify-center gap-1.5 rounded px-3 py-1.5 text-xs font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-40'

export const BTN_PRIMARY = `${BTN_BASE} bg-primary text-white hover:bg-primary-600`
export const BTN_TEAL = `${BTN_BASE} bg-teal text-white hover:bg-teal-600`
export const BTN_SECONDARY =
  'inline-flex items-center justify-center gap-1.5 rounded border border-gray-300 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40'

export const INPUT =
  'rounded border border-gray-200 px-3 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-primary/30 disabled:bg-gray-50 disabled:text-gray-400'
